/*
 * Списки микрофонов, динамиков и камер для выбора. Chrome на Windows отдаёт, кроме настоящих
 * устройств, два служебных: deviceId 'default' («Default - …» — устройство по умолчанию в системе)
 * и 'communications' («Communications - …» — устройство связи). К названиям USB-устройств он
 * дописывает коды производителя и модели «(03f0:078b)». На три микрофона в системе выходило пять
 * строк, из них три — один и тот же SoloCast. Служебные прячем: у нас своя строка «По умолчанию»,
 * она и следует за системой. Коды из названий убираем, как Discord.
 */

const PSEUDO = new Set(['default', 'communications'])
const USB_ID = /\s*\([0-9a-f]{4}:[0-9a-f]{4}\)\s*$/i

/** Служебное устройство Chrome, а не настоящее. */
export const isPseudoDevice = (id: string): boolean => PSEUDO.has(id)

/** Название для списка; пока доступа не дали, названий нет — тогда «Устройство N». */
export function deviceLabel(d: Pick<MediaDeviceInfo, 'label'>, i: number): string {
  return d.label ? d.label.replace(USB_ID, '') : `Устройство ${i + 1}`
}

/**
 * Что можно выбрать: без служебных и без устройств с пустым id. Пустой id бывает, пока не дали
 * доступ: выбрать такое нельзя, а с «По умолчанию» (тоже пустая строка) загорались две галочки.
 */
export function selectableDevices<T extends Pick<MediaDeviceInfo, 'deviceId'>>(list: T[]): T[] {
  return list.filter((d) => d.deviceId && !isPseudoDevice(d.deviceId))
}

/** Какое устройство система сейчас считает основным — из служебного «Default - …»; null, если не знаем. */
export function systemDefaultLabel(list: Pick<MediaDeviceInfo, 'deviceId' | 'label'>[]): string | null {
  const d = list.find((x) => x.deviceId === 'default' && x.label)
  return d ? d.label.replace(/^Default\s*-\s*/i, '').replace(USB_ID, '') : null
}
